export default {
  GetCustomerExportList(state) {
    return state.customerList;
  }
};
